import React from 'react';
import modernHomeImage from '../img/elevation_img_8.avif';
import './ProjectStyles.css';

const ModernFamilyHome = () => {
  return (
    <div className='project-container'>
      <h2>Modern Family Home</h2>
      <img className='project-image' src={modernHomeImage} alt="Modern Family Home" />
      <div className='project-details'>
        <p className='project-description'>
          Nestled in a serene and family-oriented neighborhood, this modern family home offers a harmonious blend of contemporary design and comfortable living. Crafted with meticulous attention to detail, the residence boasts clean lines, expansive windows, and a thoughtful layout that maximizes natural light and functionality.
        </p>
        <h3>Key Features:</h3>
        <ul>
          <li>Spacious open-plan living and dining area, perfect for family gatherings.</li>
          <li>Gourmet kitchen featuring state-of-the-art, integrated appliances and a large center island.</li>
          <li>Luxurious master suite with a walk-in closet and a spa-like ensuite bathroom with a soaking tub and separate shower.</li>
          <li>Three additional generously sized bedrooms, each with ample closet space.</li>
          <li>Well-appointed guest bathroom and a convenient powder room on the main floor.</li>
          <li>Dedicated home office or study space, ideal for remote work or learning.</li>
          <li>Expansive, beautifully landscaped private garden with a spacious patio for outdoor dining and relaxation.</li>
          <li>Energy-efficient design incorporating sustainable materials and smart home technology.</li>
          <li>Attached double garage with direct access to the home.</li>
          <li>Smart climate control and security systems for enhanced comfort and peace of mind.</li>
        </ul>
        <p>
          The interior design emphasizes a minimalist aesthetic with high-quality finishes, including hardwood flooring, custom cabinetry, and designer fixtures. Large windows throughout the home not only flood the interiors with natural light but also offer picturesque views of the surrounding greenery.
        </p>
        <p>
          The exterior of the home showcases a striking combination of natural wood cladding and sleek concrete accents, creating a sophisticated and contemporary facade. The thoughtfully designed garden provides a private oasis for outdoor activities and entertaining, making it an extension of the living space.
        </p>
        <p>
          Located within close proximity to top-rated schools, lush parks, and convenient shopping centers, this modern family home offers an exceptional lifestyle in a desirable location. It's more than just a house; it's a place where memories are made and families thrive.
        </p>
        <h3>Materials and Sustainability:</h3>
        <ul>
          <li>Locally sourced, sustainable wood for exterior accents.</li>
          <li>Energy-efficient windows and doors to minimize heat loss and gain.</li>
          <li>High-performance insulation throughout the building envelope.</li>
          <li>Provision for solar panel installation on the roof.</li>
          <li>Water-efficient landscaping with native plant species.</li>
          <li>Use of low-VOC (Volatile Organic Compounds) paints and finishes for healthier indoor air quality.</li>
        </ul>
        <h3>Location Highlights:</h3>
        <ul>
          <li>Short drive to reputable schools and educational institutions.</li>
          <li>Easy access to nearby parks, walking trails, and recreational facilities.</li>
          <li>Conveniently located near shopping malls, grocery stores, and local amenities.</li>
          <li>Excellent transportation links, providing easy access to the city center and beyond.</li>
          <li>Quiet and safe neighborhood, ideal for raising a family.</li>
        </ul>
      </div>
    </div>
  );
};

export default ModernFamilyHome;